import { useEffect } from 'react';

const useResizeObserver = <T extends HTMLElement>(
  element: T | undefined,
  callback: ResizeObserverCallback,
) =>
  useEffect(() => {
    if (element) {
      const resizeObserver = new ResizeObserver(callback);

      resizeObserver.observe(element);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [element, callback]);

export default useResizeObserver;
